import { render, staticRenderFns } from "./SequenceEvaluationsDetails.vue?vue&type=template&id=53f96c4a&scoped=true"
import script from "./SequenceEvaluationsDetails.vue?vue&type=script&lang=js"
export * from "./SequenceEvaluationsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f96c4a",
  null
  
)

export default component.exports